<template>
  <div>
    <v-container :class="containerClass">
      <h3>{{toolbarTitle}}</h3>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                Payment Type
              </th>
              <th class="text-left"></th>
              <th class="text-left"></th>
              <th class="text-left"></th>
              <th class="text-left">
                <v-btn
                  class="mx-2 tmc-payment-details-plus-icon" color="primary"
                  fab icon x-small
                  @click="addOne"
                  v-if="hideUnhidePaymentAndBatchPaymentDetails.canAddPaymentDetails"
                >
                  <v-icon>
                    {{icons.mdiPlus}}
                  </v-icon>
                </v-btn>
                <!--
                  NOTE on `showFortePaymentBtn`: despite the "Forte" name, this is
                  the SHARED on/off gate for ALL three gateway buttons below
                  (Forte1, Payrix, and Forte2). It is driven by the legacy Forte1
                  config (renderForteComponentFlag + defaultForteConfig.isRequiredForte),
                  so Payrix and Forte2 buttons also stay hidden unless that Forte1
                  `isRequiredForte` flag is on. Full explanation on the computed below.
                -->
                <FortePayment
                  v-if="showFortePaymentBtn && !isPayrix && !isForte2"
                  @forteResponse="forteResponse"
                />
                <!-- gated by showFortePaymentBtn (shared Forte1 flag — see computed) -->
                <v-btn
                    v-if="showFortePaymentBtn && isPayrix && programType !== 'MISC' && programType !== 'MTG'"
                    @click="handlePayrix"
                    elevated
                    >Proceed to Pay
                </v-btn>
                <!-- gated by showFortePaymentBtn (shared Forte1 flag — see computed) -->
                <v-btn
                    v-if="showFortePaymentBtn && isForte2 && programType !== 'MISC' && programType !== 'MTG'"
                    @click="handleForte2"
                    elevated
                    >Proceed to Pay
                </v-btn>
              <PayrixPaymentDialog
                v-if="isPayrix && isDialogOpen"
                :fieldNameLists="['Total Due', 'Convenience fee (credit)', 'Convenience fee (debit)',]"
                :fieldAmtLists="[totalAmount, convenienceFee]"
                :totalAmount="totalAmount"
              />
              <Forte2PaymentDialog
                v-if="isForte2 && isForte2DialogOpen"
                :fieldNameLists="['Total Due', 'Convenience fee (credit)', 'Convenience fee (debit)',]"
              />
              </th>
              <th class="text-left"
              v-if="hideUnhidePaymentAndBatchPaymentDetails.showBatchPaymentUtility">
                <v-btn
                  class="mx-2 edit-batch-payment-details-btn"
                  color="primary"
                  small
                  @click="emitEditBatchPaymntItem"
                >
                  Edit Batch Payment
                </v-btn>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in editedItem"
              :key="index"
            >
              <td>
                <v-select
                  v-model="item.paymentType"
                  label="Payment Type"
                  :items="cmnEnums.cmnPaymentTypes"
                  :readonly="isReadOnly"
                  item-text="description"
                  item-value="name"
                  class="tmc-payment-details-paymentType"
                  @change="somethingChanged(); onChangePaymentType(index);
                   onChangeMtgPaymentType(index); onChangeCcTypeOrAmount(item);"
                  dense
                  single-line
                ></v-select>
              </td>
              <td v-if="item.paymentType === 'CASH'">
                <v-text-field
                  dense
                  single-line
                  hint="Cash Received"
                  persistent-hint
                  v-model="item.cashReceived"
                  :readonly="isReadOnly"
                  @blur="somethingChanged"
                  class="tmc-payment-details-cashReceived"
                ></v-text-field>
              </td>
              <td v-if="item.paymentType === 'CHECK'">
                <v-text-field
                  dense
                  single-line
                  hint="Check Number"
                  persistent-hint
                  :readonly="isReadOnly"
                  v-model="item.checkNumber"
                  class="tmc-payment-details-checkNumber"
                  @blur="somethingChanged"
                ></v-text-field>
              </td>
              <td v-if="item.paymentType === 'EFT'">
                <v-select
                  dense
                  single-line
                  hint="EFT Type"
                  persistent-hint
                  v-model="item.eftType"
                  v-if="item.paymentType === 'EFT'"
                  item-text="description"
                  item-value="name"
                  class="tmc-payment-details-eftType"
                  :items="cmnEnums.cmnEFTTypes"
                  :readonly="isReadOnly"
                  @blur="somethingChanged"
                ></v-select>
              </td>
              <td v-if="item.paymentType === 'CREDIT'">
                <v-select
                  v-model="item.creditType"
                  hint="CC Type"
                  persistent-hint
                  item-text="description"
                  item-value="name"
                  class="tmc-payment-details-creditType"
                  dense
                  single-line
                  :items="cmnEnums.cmnCardTypes"
                  :readonly="isReadOnly"
                  @blur="somethingChanged"
                ></v-select>
              </td>
              <td>
                <v-text-field
                  dense
                  single-line
                  :hint="settingAmountPlaceHolder(item)"
                  :readonly="isReadOnly"
                  persistent-hint
                  v-model.number="item.amount"
                  class="tmc-payment-details-amount"
                  @blur="somethingChanged(); calculateCashReceived(index);
                  onChangeCcTypeOrAmount(item);"
                  @keydown.enter="somethingChanged"
                  @keydown="shortcutHandler($event, item.paymentType, 'amount', index);"
                ></v-text-field>
              </td>
              <td v-if="item.paymentType === 'CASH'">
                <v-text-field
                  dense
                  single-line
                  hint="Change"
                  persistent-hint
                  :readonly="isReadOnly"
                  v-model="item.cashChange"
                  class="tmc-payment-details-change"
                  @blur="somethingChanged"
                  @keydown.enter="somethingChanged"
                  @keydown="shortcutHandler($event, item.paymentType, 'change', index);"
                ></v-text-field>
              </td>
              <td v-if="item.paymentType === 'CHECK'">
                <v-text-field
                  dense
                  single-line
                  hint="Paid By"
                  persistent-hint
                  v-uppercase=globalSettingItem.conEverythingToCaps
                  v-model="item.checkPaidBy"
                  class="tmc-payment-details-paidBy"
                  :readonly="isReadOnly"
                  @blur="somethingChanged"
                  @keydown.enter="somethingChanged"
                  @keydown="shortcutHandler($event, item.paymentType, 'paidBy', index);"
                ></v-text-field>
              </td>
              <td v-if="item.paymentType === 'EFT' || item.paymentType === 'CREDIT'"></td>
              <td v-if="isTotal">
                <v-checkbox
                  v-if="!isReadOnly && item.paymentType === 'CREDIT' && programType === 'MISC' && isPayrix && globalSettingItem.feeWaiverMiscellaneous"
                  v-model="item.waiveFees"
                  @change="somethingChanged"
                  label="Waive Fees"
                  hide-details
                  dense
                  class="tmc-payment-details-waive-fees d-inline-flex mr-6"
                />
                <v-btn
                  v-if="!isReadOnly && item.paymentType === 'CREDIT' && (programType === 'MISC' || programType === 'MTG') && isPayrix"
                  class="input-text-size mr-6"
                  color="primary"
                  small
                  @click="handlePayrix(index)"
                >
                  Proceed to pay
                </v-btn>
                <v-icon
                  v-if="!isReadOnly"
                  small class="mr-2 tmc-payment-details-delete-icon"
                  tabindex="-1"
                  @click="removeOne(item)"
                >
                  {{icons.mdiDelete}}
                </v-icon>
              </td>
            </tr>
            <tr v-if="isTotal"
            class="blue--text tmc-payemnt-details-total-amount">
              <td colspan="2" id="total-trans-amount"
              v-if="((editedItem || []).length) !== 0">
                Total : ${{ amountFormat(amountRemaining) }}
              </td>
          </tr>
        </tbody>
      </template>
      </v-simple-table>
    </v-container>
  </div>
</template>

<script>
import {
  mdiPlus,
  mdiDelete,
} from '@mdi/js';
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import FortePayment from '../FortePayment.vue';
import PayrixPaymentDialog from '../PayrixPaymentDialog.vue';
import Forte2PaymentDialog from '../Forte2PaymentDialog.vue';

import {
  amountFormat,
  amountToNumber,
  isTabOrPlus,
  checkStringEmptiness,
} from '../../../util/shared/vue-global';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';

const defaultItem = {
  paymentType: '',
  amount: 0,
};
const isCreditItem = (item) => (item.paymentType === 'CREDIT');

export default {
  name: 'PaymentDetailsComponent',
  mixins: [GlobalToCaps],
  components: {
    FortePayment,
    PayrixPaymentDialog,
    Forte2PaymentDialog,
  },
  created() {
    window.addEventListener('keydown', this.shortcutHandler);
    this.onLoadDialogBox();
  },
  destroyed() {
    window.removeEventListener('keydown', this.shortcutHandler);
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'trans-dialog',
    },
    value: {
      type: Array,
      default: () => ([]),
    },
    whomString: {
      type: String,
      default: '',
    },
    cmnEnums: {
      type: Object,
      default: () => ({}),
    },
    paymentTypeFlags: {
      type: Object,
      default: () => ({}),
    },
    defaultPaymentType: {
      type: Object,
      default: () => ({}),
    },
    defaultForteConfig: {
      type: Object,
      default: () => ({}),
    },
    amount: [Number, String],
    isDialogBoxVisible: {
      type: Boolean,
      default: false,
    },
    isTotal: {
      type: Boolean,
      default: false,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    toolbarTitle: {
      type: String,
      default: 'Items',
    },
    transactionId: {
      type: String,
      default: null,
    },
    paymentDetailsFlags: {
      type: Object,
      default: () => ({}),
    },
    addDefaultRow: {
      type: Boolean,
      default: true,
    },
    programType: {
      type: String,
      default: '',
    },
    miscReceiptItem: {
      type: Object,
      default: () => ({}),
    },
    mtgReceiptItem: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    icons: {
      mdiPlus,
      mdiDelete,
    },
    renderForteComponentFlag: false,
    totalAmount: 0,
    convenienceFee: 0,
  }),
  watch: {
    isDialogBoxVisible() {
      if (this.isDialogBoxVisible) {
        this.onLoadDialogBox();
      } else {
        this.renderForteComponentFlag = false;
      }
    },
    isReadOnly(val) {
      // Leaving read-only (e.g. un-checking MTG/MISC Correction) puts the grid back
      // in play, so restore the blank starter row `onLoadDialogBox` would have added.
      if (!val) {
        this.onLoadDialogBox();
      }
    },
    payrixSuccessFlag: {
      immediate: false,
      handler(val) {
        if (val && (this.programType === 'MISC' || this.programType === 'MTG')) {
          this.$emit('payrixSuccess');
        }
      },
    },
  },
  computed: {
    ...mapGetters('user', ['getSettings']),
    ...mapState({
      miscSettingItem: (state) => state.SystemConfig.miscSettingItem || {},
      mtgSettingItem: (state) => state.SystemConfig.mtgSettingItem || {},
      odSettingItem: (state) => state.SystemConfig.odSettingItem || {},
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem || {},
      paymentSettingItem: (state) => state.SystemConfig.paymentSettingItem || {},
      payrixSuccessFlag: (state) => state.common.payrixPayment.paymentSuccessFlag,
      isDialogOpen: (state) => state.common.payrixPayment.isDialogOpen,
      isForte2DialogOpen: (state) => state.common.forte2Payment.isDialogOpen,
    }),
    editedItem: {
      get() {
        const newVal = JSON.parse(JSON.stringify(this.value));
        const updatedValue = newVal.map(this.loadInitialValues);
        return updatedValue;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    amountRemaining() {
      let totalRemainingPaymentAmount = amountToNumber(this.amount);
      for (let i = 0; i < (this.editedItem || []).length; i += 1) {
        totalRemainingPaymentAmount -= amountToNumber(this.editedItem[i].amount);
      }
      this.$emit('totalRemainingPaymentAmount', totalRemainingPaymentAmount);
      return totalRemainingPaymentAmount;
    },
    reqdSelectValidation() {
      return [
        (value) => !!value || 'Required',
      ];
    },
    totalCreditAmount() {
      let totalCrediAmtSum = 0.00;
      (this.editedItem || []).forEach((item) => {
        if (item.paymentType === 'CREDIT') {
          totalCrediAmtSum += amountToNumber(item.amount);
        }
      });
      return totalCrediAmtSum;
    },
    // Shared visibility gate for ALL credit-card "Proceed to Pay" buttons
    // (Forte1, Payrix, AND Forte2) — NOT just Forte1, despite the name.
    // Driven entirely by legacy Forte1 config:
    //   - renderForteComponentFlag: flips true once the payment dialog loads.
    //   - defaultForteConfig.isRequiredForte: a Forte1 enablement flag.
    // Consequence: the Payrix and Forte2 buttons also stay hidden unless the
    // legacy Forte1 `isRequiredForte` flag is turned on. (Kept this way on
    // purpose so all gateway buttons share one switch; matches Payrix.)
    showFortePaymentBtn() {
      return this.renderForteComponentFlag
        && this.defaultForteConfig.isRequiredForte
        && !this.isReadOnly;
    },
    enableAutofillMiscReceivedOf() {
      return this.miscSettingItem.enableAutofillofPaidByfromReceivedOf;
    },
    enableAutofillMtgReceivedOf() {
      return this.mtgSettingItem.enableAutofillofPaidByfromReceivedOf;
    },
    isTransactionId() {
      return !checkStringEmptiness(this.transactionId);
    },
    isAmountRemainingZero() {
      return amountToNumber(this.amountRemaining) === 0;
    },
    hideUnhidePaymentAndBatchPaymentDetails() {
      const flags = {
        canAddPaymentDetails: false,
        showBatchPaymentUtility: false,
      };
      if (Object.keys(this.paymentDetailsFlags).length > 0) {
        if (this.paymentDetailsFlags.isCallForBatchPayment && this.isTransactionId) {
          flags.showBatchPaymentUtility = true;
        } else if (this.paymentDetailsFlags.isCallForNormalPayment && !this.isTransactionId) {
          flags.canAddPaymentDetails = !this.isAmountRemainingZero;
        }
      } else {
        flags.canAddPaymentDetails = !this.isAmountRemainingZero;
      }
      if (this.isReadOnly) {
        // A read-only grid (batch payments, or a MTG/MISC correction) never grows rows.
        flags.canAddPaymentDetails = false;
      }
      return flags;
    },
    containerClass() {
      return this.getSettings.lightdark === 'light' ? 'grey lighten-5 mb-6' : '';
    },
    isPayrix() {
      const program = (this.programType || '').toUpperCase();
      if (this.odSettingItem.selectedGateway !== 'payrix') return false;
      if (program === 'MISC') {
        return !!this.miscSettingItem.payrixMerchantId && !!this.paymentSettingItem.payrixPublicKey;
      }
      if (program === 'MTG') {
        return !!this.mtgSettingItem.payrixMerchantId && !!this.paymentSettingItem.payrixPublicKey;
      }
      const excludedPrograms = ['OD'];
      if (excludedPrograms.includes(program)) return false;
      return !!this.odSettingItem.payrixMerchentId && !!this.odSettingItem.payrixApiKey;
    },
    isForte2() {
      const program = (this.programType || '').toUpperCase();
      if (this.odSettingItem.selectedGateway !== 'forte2') return false;
      // Demo: TAX program only. MISC/MTG/OD wiring is a later phase.
      const excludedPrograms = ['OD', 'MISC', 'MTG'];
      if (excludedPrograms.includes(program)) return false;
      // Gateway-level REST creds live on odSettingItem (mirrors payrixMerchentId/payrixApiKey);
      // the client tokenization id lives on paymentSettingItem (mirrors payrixPublicKey).
      return !!this.odSettingItem.forte2ApiAccessId
        && !!this.odSettingItem.forte2ApiSecureKey
        && !!this.paymentSettingItem.forte2ApiLoginId;
    },
  },
  mounted() {
    this.setConfigData({});
    this.evaluatePayrixStatus();
  },
  methods: {
    ...mapActions('ForteService', [
      'fetchForteConfig',
    ]),
    ...mapActions('SystemConfig', [
      'loadConfig',
    ]),
    ...mapActions('common/payrixPayment', [
      'setPaymentContext',
      'setMiscReceiptData',
      'setMtgReceiptData',
      'setPayrixPaymentType',
      'setPayrixPaymentData',
      'toggleDialog',
    ]),
    ...mapActions('common/forte2Payment', {
      setForte2PaymentData: 'setForte2PaymentData',
      setForte2PaymentType: 'setForte2PaymentType',
      toggleForte2Dialog: 'toggleDialog',
    }),
    ...mapMutations('ForteService', [
      'setConfigData',
    ]),
    ...mapMutations('base/crud', ['setIsVisible']),

    async handlePayrix(index) {
      if (!this.isPayrix) return;
      // Header button (no index): preserve original stub behavior for non-MISC programs
      if (index === undefined) {
        this.totalAmount = this.totalCreditAmount;
        return;
      }
      await this.loadConfig({ requiredScope: 'paymentConfig' });
      // Per-row MISC Payrix flow (mirrors OD/CreditDetails fee math)
      const amt = amountToNumber(this.editedItem[index].amount);
      if (!amt || amt <= 0) {
        alert('Please enter a valid amount');
        return;
      }
      const isWaived = this.programType === 'MISC'
        && !!this.editedItem[index].waiveFees
        && !!this.globalSettingItem.feeWaiverMiscellaneous;
      const creditFeePercentage = isWaived ? 0 : amountToNumber(this.paymentSettingItem.payrixCreditPercentage);
      const debitFeePercentage = isWaived ? 0 : amountToNumber(this.paymentSettingItem.payrixDebitPercentage);
      const debitFeeFlat = isWaived ? 0 : amountToNumber(this.paymentSettingItem.payrixDebitFeeFlat);
      const debitAmtLimit = isWaived ? 0 : amountToNumber(this.paymentSettingItem.payrixDebitAmtLimit);
      const convenienceFeeCredit = isWaived ? 0 : amountToNumber((amt * creditFeePercentage) / 100);
      const totalPlusCreditFee = amountToNumber(amt + convenienceFeeCredit);
      const eCheckFee = amountToNumber(this.paymentSettingItem.payrixEcheckFee);
      const totalPlusEcheckFee = amountToNumber(amt + eCheckFee);
      let convenienceFeeDebit = 0;
      if (debitAmtLimit > 0 && amt < debitAmtLimit) {
        convenienceFeeDebit = debitFeeFlat;
      } else {
        convenienceFeeDebit = amountToNumber((amt * debitFeePercentage) / 100);
      }
      const totalPlusDebitFee = amountToNumber(amt + convenienceFeeDebit);
      const payrixPaymentData = {
        totalAmount: amt,
        convenienceFeeCredit,
        totalPlusCreditFee,
        convenienceFeeDebit,
        totalPlusDebitFee,
        creditFeePercentage,
        debitFeePercentage,
        debitFeeFlat,
        eCheckFee,
        totalPlusEcheckFee,
        waiveFees: isWaived,
      };
      await this.setPaymentContext(this.programType);
      if (this.programType === 'MISC') {
        await this.setMiscReceiptData({
          receiptNumber: this.miscReceiptItem.receiptNumber,
          receivedOf: this.miscReceiptItem.whomStr,
          fiscalYear: this.miscReceiptItem.fiscalYear,
        });
      } else if (this.programType === 'MTG') {
        await this.setMtgReceiptData({
          receiptNumber: this.mtgReceiptItem.receiptNumber,
          receivedOf: this.mtgReceiptItem.receivedOf,
          fiscalYear: this.mtgReceiptItem.fiscalYear,
        });
      }
      await this.setPayrixPaymentType('CREDIT');
      await this.setPayrixPaymentData(payrixPaymentData);
      await this.toggleDialog(true);
    },
    async handleForte2() {
      if (!this.isForte2) return;
      await this.loadConfig({ requiredScope: 'paymentConfig' });
      // TAX demo: charge the sum of the CREDIT payment rows.
      const amt = amountToNumber(this.totalCreditAmount);
      if (!amt || amt <= 0) {
        alert('Please enter a valid amount');
        return;
      }
      const creditFeePercentage = amountToNumber(this.paymentSettingItem.forte2CreditPercentage);
      const debitFeePercentage = amountToNumber(this.paymentSettingItem.forte2DebitPercentage);
      const forte2PaymentData = {
        totalAmount: amt,
        creditFeePercentage,
        debitFeePercentage,
        // Flat eCheck fee ($) from the rate plan. amountToNumber backfills a
        // missing/empty key to 0, so pre-eCheck-fee configs stay fee-free.
        forte2EcheckFee: amountToNumber(this.paymentSettingItem.forte2EcheckFee),
        // config the dialog needs (Forte.js + backend REST creds).
        // Fee/login/CDN come from paymentConfig; gateway REST creds from odSettingItem.
        forte2CdnUrl: this.paymentSettingItem.forte2CdnUrl,
        forte2ApiLoginId: this.paymentSettingItem.forte2ApiLoginId,
        forte2BaseUrl: this.odSettingItem.forte2BaseUrl,
        forte2OrgId: this.odSettingItem.forte2OrgId,
        forte2AuthOrgId: this.odSettingItem.forte2AuthOrgId,
        forte2LocId: this.odSettingItem.forte2LocId,
        forte2ApiAccessId: this.odSettingItem.forte2ApiAccessId,
        forte2ApiSecureKey: this.odSettingItem.forte2ApiSecureKey,
      };
      await this.setForte2PaymentType('CREDIT');
      await this.setForte2PaymentData(forte2PaymentData);
      await this.toggleForte2Dialog(true);
    },
    evaluatePayrixStatus() {
      const status = this.isPayrix;
      return status;
    },
    amountFormat,
    amountToNumber,
    loadInitialValues(item) {
      return {
        ...item,
        amount: amountFormat(amountToNumber(item.amount)),
      };
    },
    addOne() {
      // Guarded here rather than only on the + button: readonly inputs still emit
      // keydown, so `shortcutHandler` can reach addOne with the button hidden.
      if (this.isReadOnly) {
        return false;
      }
      this.$emit('input', [
        ...this.editedItem,
        {
          ...defaultItem,
        },
      ]);
      return true;
    },
    removeOne(item) {
      if (this.isReadOnly) {
        return;
      }
      this.$emit('input', [
        ...this.editedItem.filter((candidate) => item !== candidate),
      ]);
    },
    emitEditBatchPaymntItem() {
      this.$emit('emitEditBatchPaymntItem');
    },
    somethingChanged() {
      this.$emit('input', this.editedItem);
    },
    settingAmountPlaceHolder(item) {
      if (item && item.paymentType) {
        if (item.paymentType === 'CASH') {
          return 'Cash Amount';
        }
        if (item.paymentType === 'CREDIT' || item.paymentType === 'EFT') {
          return 'Amount';
        }
        if (item.paymentType === 'CHECK') {
          return 'Check Amount';
        }
      }
      return '';
    },
    autoFillCheckPaidBy(index) {
      if (this.editedItem[index].paymentType && this.editedItem[index].paymentType === 'CHECK' && this.enableAutofillMiscReceivedOf) {
        // Code-filled from Received Of, so the v-uppercase directive on the Paid By input never
        // fires for it - it only converts what the user types.
        this.editedItem[index].checkPaidBy = this.toCapsIfEnabled(this.whomString || '');
      }
      return this.editedItem;
    },
    // This is for auto fill paid by in Mtg settings
    autoFillMtgCheckPaidBy(index) {
      if (this.editedItem[index].paymentType && this.editedItem[index].paymentType === 'CHECK' && this.enableAutofillMtgReceivedOf) {
        this.editedItem[index].checkPaidBy = this.toCapsIfEnabled(this.whomString || '');
      }
      return this.editedItem;
    },
    calculateCashReceived(index) {
      if (this.editedItem[index].paymentType === 'CASH' && this.editedItem[index].amount && this.editedItem[index].cashReceived) {
        this.editedItem[index].cashReceived = amountFormat(
          amountToNumber(this.editedItem[index].cashReceived),
        );
        this.editedItem[index].cashChange = amountFormat(
          amountToNumber(this.editedItem[index].cashReceived)
          - amountToNumber(this.editedItem[index].amount),
        );
      }
      return this.editedItem;
    },
    shortcutHandler(e, paymentType, fieldName, index) {
      let totalAmount = 0;
      if (isTabOrPlus(e) && (this.isPaymentTypeSelected(paymentType, fieldName))) {
        if ((index + 1) === (this.editedItem || []).length) {
          for (let i = 0; i < (this.editedItem || []).length; i += 1) {
            totalAmount += amountToNumber(this.editedItem[i].amount);
            this.somethingChanged();
            const amountDifference = amountToNumber(this.amount) - totalAmount;
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign
            if ((Math.sign(amountToNumber(this.amount)) === 1) && (amountDifference > 0)) {
              this.addOne();
            } else if ((Math.sign(amountToNumber(this.amount)) === -1) && (amountDifference < 0)) {
              this.addOne();
            }
          }
        }
      }
    },
    isPaymentTypeSelected(paymentType, fieldName) {
      return ((paymentType === 'CHECK' && fieldName === 'paidBy')
      || (paymentType === 'CASH' && fieldName === 'change')
      || (paymentType === 'EFT' && fieldName === 'amount')
      || (paymentType === 'CREDIT' && fieldName === 'amount'));
    },
    onChangePaymentType(index) {
      this.autoFillCheckPaidBy(index);
      this.assignDefaultPaymentType(index);
    },
    // This is for autofill paid by in  Mtg setting
    onChangeMtgPaymentType(index) {
      this.autoFillMtgCheckPaidBy(index);
      this.assignDefaultPaymentType(index);
    },
    assignDefaultPaymentType(index) {
      if (this.paymentTypeFlags && this.paymentTypeFlags.eftPaymentType && this.editedItem[index].paymentType === 'EFT') {
        this.editedItem[index].eftType = (this.defaultPaymentType.eftPaymentType).toUpperCase();
      }
      if (this.paymentTypeFlags && this.paymentTypeFlags.ccPaymentType && this.editedItem[index].paymentType === 'CREDIT') {
        this.editedItem[index].creditType = (this.defaultPaymentType.ccPaymentType).toUpperCase();
      }
    },
    forteResponse(response) {
      this.$emit('forteResponse', response);
    },
    onLoadDialogBox() {
      // `addOne` no-ops while read-only, so a MTG/MISC correction no longer opens
      // holding a blank starter row (which is how corrections ended up saved with
      // a $0.00 check and a null check number).
      if (this.addDefaultRow && !this.editedItem.length > 0) {
        this.addOne();
      }
      const isCreditItemAvailable = (this.editedItem || []).find((item) => isCreditItem(item));
      if (isCreditItemAvailable) {
        this.fetchForteConfiguration();
      }
    },
    onChangeCcTypeOrAmount(item) {
      if (isCreditItem(item)) {
        this.fetchForteConfiguration();
      }
    },
    async fetchForteConfiguration() {
      if (this.defaultForteConfig.isRequiredForte) {
        // Remove forte-component from the DOM
        this.renderForteComponentFlag = false;
        // call forte event
        await this.fetchForteConfig({
          scope: this.defaultForteConfig.configScope,
          forteAmount: this.totalCreditAmount.toString(),
        });
        this.$nextTick(() => {
          // Add the forte-component back in
          this.renderForteComponentFlag = true;
        });
      }
    },
  },
};
</script>

<style lang="sass">
  .eft-rec-amount input
    text-align: right
</style>
